<template>
<div>
	<el-card class="box-card">
		<div slot="header" class="flex-be">
			<div class="operate-left">
				<el-button size="small" class="activeStyle" style="margin-right:10px" type="primary" plain
					@click="addCommodity()">
					新增商品
				</el-button>
				<el-cascader :clearable="true" style="width: 250px;margin-right:10px" @change="satellitSeach"
					size="small" placeholder="请选择卫星类别" :props="satelliteprops" v-model="orderStatus"
					:options="orderStatusList"></el-cascader>
				<!-- <el-button size="small" class="activeStyle" type="primary" plain @click="getData()">
					查询
					</el-button> -->
				<el-link type="primary" @click="bulkListing">批量上架</el-link>
				<el-link type="primary" @click="bulkRemoval">批量下架</el-link>
			</div>
			<div class="btnList">
				<el-badge class="m-r-30" v-for="(btn, index) in statusList" :key="index" :value="btn.badge"
					:hidden="btn.badge === 0">
					<el-button size="small" :class="btn.value === active ? 'activeStyle' : ''"
						:type="btn.value === active ? 'primary' : ''" plain @click="changeStatus(btn, index)">
						{{ btn.label }}
					</el-button>
				</el-badge>
			</div>
		</div>
		<div>
			<tableTotal @handleClick="handleClick" :index-show="configTable.indexShow"
				:config-data="configTable.configData" :table-data="configTable.tableData"
				:loading="configTable.loading" @handleSelectionChange="handleSelectionChange">


				<template #goodsPricedesc="{ data }">
					<div v-if="data.goodsPriceType === 1">
							<div style="color:#409EFF">{{ '¥ '+data.goodsPrice }}</div>
						</div>
						<div v-else> - </div>
						
					</template>
			</tableTotal>
			<div class="pagination_box m-t-20">
				<el-pagination @current-change="getData" @size-change="handleSizeChange"
					:current-page.sync="configTable.current" layout="total, sizes, prev, pager, next, jumper" background
					:page-sizes="[10, 15, 20]" :page-size="configTable.pageSize"
					:total="configTable.total"></el-pagination>
			</div>
		</div>
	</el-card>
</div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";

export default {
	name: "CommodityList",
	// import引入的组件需要注入到对象中才能使用
	components: {
		tableTotal
	},
	data() {
		// 这里存放数据
		return {
			active: 3,
			statusList: [
				{ value: 3, label: '全部', badge: 0 },
				{ value: 0, label: '待上架', badge: 0 },
				{ value: 1, label: '已上架', badge: 0 },
				// { value: 3, label: '待审核' },
				{ value: 2, label: '已下架', badge: 0 },
			],
			orderTime: 1,
			orderTimeList: [
				{ value: 1, label: '近三个月订单' },
				{ value: 2, label: '近半年订单' },
				{ value: 3, label: '近一年订单' },
			],
			orderStatus: '',
			orderStatusList: [],
			satelliteprops: {
				value: "id",
				label: "satelliteName",
				children: "sonSatelliteCategoryListVO"
			},
			// 配置表格
			configTable: {
				loading: false,
				indexShow: false,
				configData: [
				{
					type: "selection"
				}, {
					value: 'goodsThumbnail',
					label: '商品图片',
					type: 'img',
					align: 'left'
				}, {
					value: 'goodsName',
					label: '商品名称',
					align: 'center'
				}, {
					value: 'goodsPriceType',
					label: '价格分类',
					align: 'center',
					objList: {
						1: '实际金额',
						2: '面议',
						3: '免费',
					}
				} ,{
					value: 'goodsPrice',
					label: '商品价格',
					align: 'center',
					type: "custom",
					customName: "goodsPricedesc",
					
					// style: {
					// 	css: 'font-weight: 700;color:#e1251b;',
					// 	// currency: '￥',
					// },
					
				},{
					value: 'goodsCategory',
					label: '商品类别',
					align: 'center',
					objList: {
						1: '影像数据',
						2: '数据产品',
						3: '软件产品',
						4: '其他产品'
					}
				},
				// {
				// 	value: 'goodsDescribe',
				// 	label: '商品描述',
				// 	align: 'center',
				// 	showOverflow: true,
				// },
				{
					value: 'deliveryType', //1：线上交易；2.线下预约交易
					label: '交付方式',
					align: 'center',
					objList: {
						1: '线上交易',
						2: '线下预约交易',
						0:'-'
					}
				}, {
					value: 'createTime',
					label: '发布时间',
					align: 'left'
				}, {
					value: 'status', //状态：0.待审核；1.审核通过；2.审核不通过；
					label: '审核状态',
					align: 'center',
					objList: {
						0: '待审核',
						1: '审核通过',
						2: '审核不通过',
					}
				}, {
					value: 'shelfStatus', //	状态：0.待上架；1.上架；2.已下架；
					label: '商品状态',
					align: 'center',
					objList: {
						0: '待上架',
						1: '已上架',
						2: '已下架',
					}
				}, {
					value: 'chargingType', //	计费方式 1；按次收费；2.按周期收费
					label: '计费方式',
					align: 'center',
					objList: {
						1: '按次收费',
						2: '按周期收费',
						0:'-'

					}
				},
				{
					label: '操作',
					width: '220',
					fixed: 'right',
					type: 'handleList',
					buttonList: [
						{ label: '查看', event: 'toDetail', show: true, showText: true },
						{ label: '编辑', event: 'editData', show: true, showText: true },
						{
							label: '上架',
							event: 'shelvesPut',
							show: true,
							showText: true,
							text: '是否上架该商品?',
							condition: row => {
								return (row.shelfStatus * 1 !== 0 && row.shelfStatus * 1 !== 2);
							}
						},
						{
							label: '下架',
							event: 'shelfLower',
							show: true,
							showText: true,
							text: '是否下架该商品?',
							condition: row => {
								return (row.shelfStatus * 1 !== 1);
							}
						}
					]
				}
				],
				tableData: [], // 表格数据
				current: 1, // 当前页码
				total: 0, // 数据总条数
				pageSize: 10,
				selectedRow: []
			}
		}
	},
	created() {
		this.info();
	},
	methods: {
		info() {
			// 获取数据
			this.getData();
			// 获取 卫星类别
			this.$http.get(this.$const.common.satelliteALL).then((res) => {
				if (res.code === 200) {
					this.orderStatusList = res.data;
				}
			})
			// 获取商品各状态的个数
			this.$http.get(this.$const.SellerCenter.getcountStaus).then((res) => {
				if (res.code === 200) {
					this.statusList[0].badge = res.data.goodsAllNum;
					this.statusList[1].badge = res.data.goodsUnShelfNum;
					this.statusList[2].badge = res.data.goodsShelfNum;
					this.statusList[3].badge = res.data.goodsTakeDownNum;
				}
			})
		},
		satellitSeach() {
			this.getData()
		},
		getData() {
			this.configTable.tableData = [];
			this.configTable.loading = true;
			var params = {
				pageNum: this.configTable.current,
				pageSize: this.configTable.pageSize,
				satelliteCategoryId: this.orderStatus[1] || '',
				searchType: this.active
			}
			this.$http.post(this.$const.SellerCenter.getShopGoodsPage, params).then(res => {
				console.log(res)
				this.configTable.loading = false;
				if (res.code === 200) {
					this.configTable.tableData = res.data.list;
					this.configTable.total = res.data.total;
				}
			})
		},
		handleClick(event, data, text) {
			switch (event) {
				case 'toDetail':
					if(data.goodsCategory==1){
						window.open(this.$router.resolve({ name: "shopDetail", query: { goodsId: data.id}}).href, '_blank')

					}else{
					window.open(this.$router.resolve({ name: "productDetail", params: { id: data.id}}).href, '_blank')

					}
					break;
				case 'editData':
					// 编辑产品							
					this.$router.push({
						name: 'SellerCenter',
						query: {
							type: 'CommodityAdd',
							id: data.id,
							Goodtype: data.goodsCategory
						}
					})
					break;
				case 'shelvesPut':
					// 上架商品
					this.$http.get(this.$const.SellerCenter.goodsshelvesPut + data.id).then((res) => {
						if (res.code === 200) {
							this.$message.success('修改成功')
							var that = this;
							setTimeout(function () {
								that.$router.go(0)
							}, 1000)
						}
					})
					break
				case 'shelfLower':
					// 下架商品
					this.$http.get(this.$const.SellerCenter.goodsshelfLower + data.id).then((res) => {
						if (res.code === 200) {
							this.$message.success('修改成功')
							var that = this;
							setTimeout(function () {
								that.$router.go(0)
							}, 1000)
						}
					})
					break
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		changeStatus(data, index) {
			this.active = data.value;
			this.getData()
		},
		addCommodity() {
			this.$router.push({
				name: 'SellerCenter',
				query: {
					type: 'CommodityAdd'
				}
			})
		},
		handleSelectionChange(val){
			this.selectedRow = val
		},
		bulkListing() {
			this.$http.post(this.$const.SellerCenter.productsListing, this.selectedRow.map(item => {
				return item.id
			})).then(res => {
				if(res.code === 200 && res.data) {
					this.$message.success('批量上架商品成功')
					this.info()
				}else {
					this.$message.error('批量上架商品失败')
				}
			}).catch(error => {
				console.log(error)
			})
		},
		bulkRemoval() {
			this.$http.post(this.$const.SellerCenter.productsRemoval, this.selectedRow.map(item => {
				return item.id
			})).then(res => {
				if(res.code === 200 && res.data) {
					this.$message.success('批量下架商品成功')
					this.info()
				}else {
					this.$message.error('批量下架商品失败')
				}
			}).catch(error => {
				console.log(error)
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.operate-left {

	> .el-link {
		margin-left: 16px;
	}
}
.activeStyle {
	color: #FFF;
	background-color: #409EFF;
	border-color: #409EFF;
}

.search_condition_item {
	width: 140px;
}

.pagination_box {
	text-align: right;
}
</style>